import { Component, computed, input, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectButton } from 'primeng/selectbutton';
import { Avatar } from 'primeng/avatar';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { SelectModule } from 'primeng/select';
import { CpfCnpjMaskPipe } from '@/shared/directives/cpf-cnpj-pipe.directive';

@Component({
    selector: '[app-company]',
    standalone: true,
    imports: [CommonModule, FormsModule, SelectModule, CpfCnpjMaskPipe],
    template: `
        <div class="p-4 pl-6 flex items-center justify-between border-b">
            <p-select [options]="companies()" placeholder="Selecione" optionLabel="nome"
                [showClear]="false" appendTo="body" [(ngModel)]="companyId" class="w-full"
                optionValue="id" variant="filled" fluid (ngModelChange)="selectedCompany()"
                [ngStyle]="{ 'border-radius': '0px' }" emptyMessage="Nenhum registro encontrado.">
                <ng-template let-item pTemplate="selectedItem">
                    <div class="flex flex-col">
                        <span>{{ item?.nome }}</span>
                        <span class="text-xs">{{ item?.cpfCnpj | cpfCnpjMask }}</span>
                    </div>   
                </ng-template>

                <ng-template let-item pTemplate="item">
                     <div class="flex flex-col">
                        <span>{{ item?.nome }}</span>
                        <span class="text-xs">{{ item?.cpfCnpj | cpfCnpjMask }}</span>
                    </div>   
                </ng-template>
            </p-select>
        </div>
    `,
    host: {
        '[class]': 'hostClass()'
    }
})
export class AppCompany {
    styleClass = input<string>('');

    hostClass = computed(
        () =>
            (this.styleClass() ?? '') +
            ' rounded-2xl bg-surface-0 dark:bg-surface-950 shadow-[0px_129.205px_36.493px_0px_rgba(44,54,87,0.00),_0px_82.849px_33.534px_0px_rgba(44,54,87,0.01),_0px_46.356px_27.616px_0px_rgba(44,54,87,0.03),_0px_20.712px_20.712px_0px_rgba(44,54,87,0.05),_0px_4.932px_11.836px_0px_rgba(44,54,87,0.06)] dark:shadow-stroke'
    );

    companies = signal<any[]>([]);

    currentItems = computed(() => this.companies());

    user: any = {};

    companyId: any;

    constructor(
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.loadCompanies();
    }

    loadCompanies() {
        this.authService.listarFiliais({pageSize: 100, offSet: 0}).subscribe({
            next: (data) => {
                this.companies.set(data.result.lista);
                this.loadCurrentCompany();
            }
        })
    }

    loadCurrentCompany() {
        this.user = this.authService.getUserLogged().result;
        this.companyId = this.user.clienteId;
    }

    selectedCompany() {
        this.authService.alterarEmpresa({ id: this.companyId }).subscribe({
            next: (data) => {
                const usuario = {
                    result: {
                        ...this.user,
                        clienteId: this.companyId
                    }
                }

                localStorage.setItem('userLogged', JSON.stringify(usuario));

                localStorage.removeItem('access_token');
                localStorage.setItem('access_token', data.result);

                window.location.reload();
            }
        })
    }
}
